module.exports = __webpack_public_path__ + "img/dots-vertical.6c25afd4.svg";